import { Action } from '@ngrx/store';
import { CustomOrder } from '@order/const';
import { Order, PROCESS_FEATURE, StateUtils } from '@spartacus/core';
import { PLACED_ORDER_PROCESS_ID } from '../checkout-state';

export const PLACE_ORDER = '[Checkout] Place Order';
export const PLACE_ORDER_FAIL = '[Checkout] Place Order Fail';
export const PLACE_ORDER_SUCCESS = '[Checkout] Place Order Success';
export const CLEAR_PLACE_ORDER = '[Checkout] Clear Place Order';

export const SET_ACTIVE = '[Checkout] Set active mode';
export const ACTIVE_MODE_RESET = '[Checkout] Reset active mode';
export const CHECKOUT_RESET = '[Checkout] Reset checkout';
export const RESET_DELIVERY_FEATURES = '[Checkout] Reset Delivery Features';

export const SET_REDIRECTED_TO_PAYMENT_PAGE = '[Checkout] Set redirected to payment page';
export const SET_ORDER_DETAILS = '[Checkout] Set Order Details';
export const RESET_ORDER_DETAILS = '[Checkout] Reset Order Details';

export class PlaceOrder extends StateUtils.EntityLoadAction {
  readonly type = PLACE_ORDER;

  constructor(public payload: { cartId: string; termsChecked: boolean }) {
    super(PROCESS_FEATURE, PLACED_ORDER_PROCESS_ID);
  }
}

export class PlaceOrderFail extends StateUtils.EntityFailAction {
  readonly type = PLACE_ORDER_FAIL;

  constructor(public payload: any) {
    super(PROCESS_FEATURE, PLACED_ORDER_PROCESS_ID, payload);
  }
}

export class PlaceOrderSuccess extends StateUtils.EntitySuccessAction {
  readonly type = PLACE_ORDER_SUCCESS;

  constructor(public payload: Order) {
    super(PROCESS_FEATURE, PLACED_ORDER_PROCESS_ID);
  }
}

export class ClearPlaceOrder extends StateUtils.EntityLoaderResetAction {
  readonly type = CLEAR_PLACE_ORDER;

  constructor() {
    super(PROCESS_FEATURE, PLACED_ORDER_PROCESS_ID);
  }
}

export class ResetActiveMode implements Action {
  readonly type = ACTIVE_MODE_RESET;
}

export class ResetCheckout implements Action {
  readonly type = CHECKOUT_RESET;
}

export class ResetDeliveryFeatures implements Action {
  readonly type = RESET_DELIVERY_FEATURES;
}

export class SetRedirectedToPaymentPage implements Action {
  readonly type = SET_REDIRECTED_TO_PAYMENT_PAGE;

  constructor(public payload: boolean) {}
}

export class SetOrderDetails implements Action {
  readonly type = SET_ORDER_DETAILS;

  constructor(public payload: CustomOrder) {}
}

export class ResetOrderDetails implements Action {
  readonly type = RESET_ORDER_DETAILS;
}

export type CheckoutActions =
  | PlaceOrder
  | PlaceOrderFail
  | PlaceOrderSuccess
  | ResetActiveMode
  | ResetCheckout
  | ResetDeliveryFeatures
  | SetRedirectedToPaymentPage
  | SetOrderDetails;
